export { HeadingRender } from './HeadingRender';
